import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import 'jquery-zoom';
import '../styles/tena.scss';
import Application from './application';

import Vue from 'vue';
import VueResource from 'vue-resource';
import { Plugin } from 'vue2-storage';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import Swiper from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';

import XSellStore from './vendors/cross-sell/store-xsell';
import PanelUp from './vendors/cross-sell/data-panelup';
import CartXSellSlider from './vendors/cross-sell/data-cart-xsell-slider';

window.Swiper = Swiper;

Alpine.store('xsell', XSellStore);
Alpine.data('panelUp', PanelUp);
Alpine.data('cartXSellSlider', CartXSellSlider);
Alpine.plugin(collapse);
window.Alpine = Alpine;

Alpine.start();

const ONE_DAY = 60 * 60 * 24 * 1000;

window.Vue = Vue;
Vue.use(VueResource);
Vue.use(Plugin, {
  prefix: 'tena__',
  driver: 'local',
  ttl: ONE_DAY,
});

Application.init();
window.productRecommendation = Application.ProductRecommendation;
